module.exports = __webpack_public_path__ + "img/2.fea87a78.jpg";